
import React from 'react';
import { Button } from 'antd';
import { getQueryString } from './utils';

export const isImg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?/;
export const getChildrenToRender = (item, i) => {
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children = typeof item.children === 'string' && item.children.match(isImg)
    ? React.createElement('img', { src: item.children, alt: 'img' })
    : item.children;
  if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  }
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};
/** 获取所有参数
* @returns json/object
*/
export function getQueryStringParams(url) {
  const search = decodeURIComponent(url);
  const tempArr = search !== '' ? search.substr(1).split('token=') : [];
  if (tempArr.length > 1) {
    return {
      token: tempArr[1].split('#/')[0]
    };
  } else {
    return null
  }
}